import createReactComponent from '../createReactComponent';
var ThumbsUp = createReactComponent('ThumbsUp', [['path', {
  d: 'M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3zM7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3',
  key: '1959nf'
}]]);
export default ThumbsUp;